/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { HubSpotEnrollmentRequestHubspotContactId } from './hubSpotEnrollmentRequestHubspotContactId';

/**
 * Payload sent from HubSpot Custom Code action
 */
export interface HubSpotEnrollmentRequest {
  email: string;
  firstname: string;
  lastname: string;
  /** List of SKU/Product IDs from HubSpot */
  externalProductIds: string[];
  /** The Deal ID for auditability */
  hubspotDealId: string;
  hubspotContactId?: HubSpotEnrollmentRequestHubspotContactId;
}
